import LabelBase from '@components/common/core/DataDisplay/Label';
import TextBase from '@components/common/core/DataDisplay/Text';
import ButtonBase from '@components/common/core/Inputs/Button';
import FormBase from '@components/common/core/Inputs/Form';
import InputGroupBase from '@components/common/core/Inputs/InputGroup';
import PhoneInputBase from '@components/common/core/Utils/PhoneInput';
import styled, { css } from 'styled-components/macro';

export const Title = styled(TextBase)`
  display: inline-block;
  color: ${({ theme }) => theme.colors.gray[1]};
  font-size: 1.25rem;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: 0.16px;
  margin-bottom: 12px;
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const InfoGroup = styled.div`
  display: flex;
  gap: 12px;
`;

export const InfoText = styled(TextBase)`
  display: inline-block;
  color: ${({ theme }) => theme.colors.gray[1]};
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 105%;
`;

export const SubmitButton = styled(ButtonBase)`
  width: 100%;
`;

export const Form = styled(FormBase)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;
`;

export const InputGroup = styled(InputGroupBase)``;

export const Label = styled(LabelBase)``;

export const PhoneInput = styled(PhoneInputBase)`
  border-radius: 5px;
  height: 42px;
  border: 1px solid transparent;
  transition: all 0.3s;

  ${({ isError, theme, value }) =>
    Boolean(value) &&
    Boolean(!isError) &&
    css`
      background-color: ${theme.colors.black.default};
      border-color: ${theme.colors.success.default};
    `}

  ${({ isError, theme }) =>
    Boolean(isError) &&
    css`
      border-color: ${theme.colors.danger.default};
      background-color: ${theme.colors.black.default};
    `}

  .form-control {
    height: 42px;
    background-color: ${({ theme }) => theme.colors.background[2]};
    border: 0;
    width: 100%;
    color: ${({ theme }) => theme.colors.gray[1]};
    font-family: ${({ theme }) => theme.fonts.body};
    font-weight: 500;
    font-size: 1rem;
    transition: all 0.3s;

    ${({ isError, theme, value }) =>
      Boolean(value) &&
      Boolean(!isError) &&
      css`
        background-color: ${theme.colors.black.default};
      `}

    ${({ isError, theme }) =>
      Boolean(isError) &&
      css`
        background-color: ${theme.colors.black.default};
      `}
  }

  .flag-dropdown {
    border: 0;
    background-color: ${({ theme }) => theme.colors.background[2]};
    border-radius: 5px;
    transition: all 0.3s;

    ${({ isError, theme, value }) =>
      Boolean(value) &&
      Boolean(!isError) &&
      css`
        background-color: ${theme.colors.black.default};
      `}

    ${({ isError, theme }) =>
      Boolean(isError) &&
      css`
        background-color: ${theme.colors.black.default};
      `}

    .selected-flag {
      background-color: ${({ theme }) => theme.colors.background[2]};
      border: 0;
      border-radius: 5px;
      transition: all 0.3s;

      ${({ isError, theme, value }) =>
        Boolean(value) &&
        Boolean(!isError) &&
        css`
          background-color: ${theme.colors.black.default};
        `}

      ${({ isError, theme }) =>
        Boolean(isError) &&
        css`
          background-color: ${theme.colors.black.default};
        `}

      &:hover {
        background-color: transparent;
      }

      &:active {
        background-color: ${({ theme }) => theme.colors.background[2]};
      }
    }

    .open {
      background-color: ${({ theme }) => theme.colors.background[2]} !important;

      ${({ isError, theme, value }) =>
        Boolean(value) &&
        Boolean(!isError) &&
        css`
          background-color: ${theme.colors.black.default} !important;
        `}

      ${({ isError, theme }) =>
        Boolean(isError) &&
        css`
          background-color: ${theme.colors.black.default} !important;
        `}
    }
  }

  .country-list {
    background-color: ${({ theme }) => theme.colors.background[2]};

    .country {
      span {
        color: ${({ theme }) => theme.colors.gray[1]};
        font-family: ${({ theme }) => theme.fonts.body};
      }

      &:hover {
        background-color: ${({ theme }) => theme.colors.gray[3]};
      }
    }

    .highlight {
      background-color: ${({ theme }) => theme.colors.gray[3]} !important;
    }
  }
`;
